export default "__VITE_ASSET__BJtiZQJM__"